import { render, staticRenderFns } from "./VehicleAnomalyRecord.vue?vue&type=template&id=8de4375e&scoped=true"
import script from "./VehicleAnomalyRecord.vue?vue&type=script&lang=js"
export * from "./VehicleAnomalyRecord.vue?vue&type=script&lang=js"
import style0 from "./VehicleAnomalyRecord.vue?vue&type=style&index=0&id=8de4375e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de4375e",
  null
  
)

export default component.exports